import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { getRouteMetadata, getStructuredData, SITE_NAME } from '../../config/seo'

const upsertMeta = (attribute, key, content) => {
  let element = document.head.querySelector(`meta[${attribute}="${key}"]`)

  if (!element) {
    element = document.createElement('meta')
    element.setAttribute(attribute, key)
    document.head.appendChild(element)
  }

  element.setAttribute('content', content)
}

const upsertLink = (rel, href) => {
  let element = document.head.querySelector(`link[rel="${rel}"]`)

  if (!element) {
    element = document.createElement('link')
    element.setAttribute('rel', rel)
    document.head.appendChild(element)
  }

  element.setAttribute('href', href)
}

const upsertStructuredData = (structuredData) => {
  let element = document.head.querySelector('#leadership-net-structured-data')

  if (!structuredData) {
    element?.remove()
    return
  }

  if (!element) {
    element = document.createElement('script')
    element.id = 'leadership-net-structured-data'
    element.type = 'application/ld+json'
    document.head.appendChild(element)
  }

  element.textContent = JSON.stringify(structuredData)
}

const SeoMetadata = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    const metadata = getRouteMetadata(pathname)
    const canonical = metadata.canonical ?? ''

    document.title = metadata.title
    upsertMeta('name', 'description', metadata.description)
    upsertMeta('name', 'robots', metadata.robots)

    if (canonical) upsertLink('canonical', canonical)
    else document.head.querySelector('link[rel="canonical"]')?.remove()

    upsertMeta('property', 'og:title', metadata.title)
    upsertMeta('property', 'og:description', metadata.description)
    upsertMeta('property', 'og:type', 'website')
    upsertMeta('property', 'og:site_name', SITE_NAME)
    upsertMeta('property', 'og:url', canonical || window.location.href)
    upsertMeta('name', 'twitter:card', 'summary')
    upsertMeta('name', 'twitter:title', metadata.title)
    upsertMeta('name', 'twitter:description', metadata.description)
    upsertStructuredData(getStructuredData(pathname))
  }, [pathname])

  return null
}

export default SeoMetadata
